import { BrandGradientDefs, type IllustrationProps, Sparkle } from "./common";

export function EmptySearch({ size = 120, ...props }: IllustrationProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 200 200"
      width={size}
      height={size}
      fill="none"
      aria-hidden
      {...props}
    >
      <BrandGradientDefs id="es" />
      {/* Magnifier ring */}
      <circle
        cx="86"
        cy="86"
        r="40"
        fill="url(#es-fill)"
        stroke="url(#es-stroke)"
        strokeWidth="3"
      />
      <circle
        cx="86"
        cy="86"
        r="32"
        fill="hsl(var(--background))"
      />
      {/* Empty horizontal lines inside ring */}
      <rect x="64" y="78" width="44" height="3" rx="1.5" fill="hsl(var(--muted-foreground))" opacity="0.3" />
      <rect x="64" y="88" width="36" height="3" rx="1.5" fill="hsl(var(--muted-foreground))" opacity="0.3" />
      <rect x="64" y="98" width="28" height="3" rx="1.5" fill="hsl(var(--muted-foreground))" opacity="0.3" />
      {/* Handle */}
      <line
        x1="118"
        y1="118"
        x2="158"
        y2="158"
        stroke="url(#es-stroke)"
        strokeWidth="6"
        strokeLinecap="round"
      />

      <Sparkle cx={172} cy={36} size={8} />
      <Sparkle cx={28} cy={32} size={6} opacity={0.5} />
    </svg>
  );
}
